(() => {
  'use strict';
  // Spartan Complex, product page nativa: barra fissa, etichetta ingrandita, GIF del meccanismo.
  // L'offerta e il carrello li gestisce il widget universale SH_OFFER_CONFIG nella sezione.
  const page = document.getElementById('sc-page');
  if (!page) return;
  const configuration = { stickyCart: { enabled: true, trigger: '#complex-quick-info' } };

const stickyCart = page.querySelector('[data-sticky-cart]');
        const stickyTrigger = configuration.stickyCart?.enabled
          ? page.querySelector(configuration.stickyCart.trigger || '#complex-quick-info')
          : null;
        if (stickyCart && stickyTrigger) {
          let stickyUpdateQueued = false;
          const updateStickyCart = () => {
            stickyUpdateQueued = false;
            const visible = stickyTrigger.getBoundingClientRect().bottom <= 0;
            stickyCart.hidden = !visible;
            page.classList.toggle('sc-sticky-is-visible', visible);
            // Keep the theme footer clear of the fixed bar.
            document.body.style.paddingBottom = visible ? `${stickyCart.offsetHeight}px` : '';
          };
          const queueStickyUpdate = () => {
            if (stickyUpdateQueued) return;
            stickyUpdateQueued = true;
            window.requestAnimationFrame(updateStickyCart);
          };
          window.addEventListener('scroll', queueStickyUpdate, { passive: true });
          window.addEventListener('resize', queueStickyUpdate);
          window.addEventListener('pageshow', queueStickyUpdate);
          if (typeof ResizeObserver === 'function') {
            new ResizeObserver(queueStickyUpdate).observe(stickyTrigger);
          }
          updateStickyCart();
        }

        // Gallery and label controls are divs with role="button": CheckoutChamp only wires funnel routing onto real buttons.
        function onActivate(element, handler) {
          element.addEventListener('click', handler);
          element.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            handler(event);
          });
        }
        const dialog = page.querySelector('#sc-label-dialog');
        const modalImage = dialog?.querySelector('img');
        page.querySelectorAll('[data-label-open]').forEach((button) => {
          onActivate(button, () => {
            if (!dialog || !modalImage) return;
            modalImage.src = button.dataset.labelOpen;
            if (typeof dialog.showModal === 'function') dialog.showModal();
            else window.open(button.dataset.labelOpen, '_blank', 'noopener');
          });
        });
        const labelClose = dialog?.querySelector('[data-label-close]');
        if (labelClose) onActivate(labelClose, () => dialog.close());
        dialog?.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });

        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        function updateMotion() {
          page.querySelectorAll('[data-motion-src]').forEach((image) => {
            image.src = motion.matches ? image.dataset.staticSrc : image.dataset.motionSrc;
          });
        }
        motion.addEventListener?.('change', updateMotion);
        updateMotion();
      })();
(() => {
  'use strict';
  // Above the fold standard (da Strength+): galleria con miniature e swipe, immagini non cliccabili.
  const root = document.querySelector('#sc-page .ss-hero');
  if (!root) return;
        const image = root.querySelector('.ss-gallery-image');
        const thumbs = [...root.querySelectorAll('.ss-thumb')];
        const thumbnailStrip = root.querySelector('.ss-thumbnails');
        const gallery = root.querySelector('.ss-gallery-main');
        let current = 0;
        const show = (index, reveal = true) => {
          if (!image || !thumbs.length) return;
          current = (index + thumbs.length) % thumbs.length;
          const source = thumbs[current].querySelector('img');
          if (!source) return;
          // Each editable thumbnail is the only source of its full-size image.
          image.src = source.getAttribute('src');
          image.alt = source.alt || '';
          image.removeAttribute('srcset');
          image.removeAttribute('data-src');
          thumbs.forEach((button, i) => button.setAttribute('aria-pressed', String(i === current)));
          if (reveal && thumbnailStrip) {
            const item = thumbs[current].getBoundingClientRect();
            const strip = thumbnailStrip.getBoundingClientRect();
            if (item.left < strip.left) thumbnailStrip.scrollLeft -= strip.left - item.left + 4;
            else if (item.right > strip.right) thumbnailStrip.scrollLeft += item.right - strip.right + 4;
          }
        };
        thumbs.forEach((button, index) => button.addEventListener('click', () => show(index)));
        const galleryKeys = event => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          const fromThumbnail = event.target.closest('.ss-thumb');
          show(current + (event.key === 'ArrowRight' ? 1 : -1));
          if (fromThumbnail) thumbs[current].focus({preventScroll:true});
        };
        gallery.addEventListener('keydown', galleryKeys);
        thumbnailStrip.addEventListener('keydown', galleryKeys);
        let swipeStart = null;
        gallery.addEventListener('pointerdown', event => {
          if (event.button === 0) swipeStart = {x:event.clientX, y:event.clientY};
        });
        gallery.addEventListener('pointerup', event => {
          if (!swipeStart) return;
          const dx = event.clientX - swipeStart.x;
          const dy = event.clientY - swipeStart.y;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
            show(current + (dx < 0 ? 1 : -1));
          }
          swipeStart = null;
        });
        gallery.addEventListener('pointercancel', () => { swipeStart = null; });
        gallery.addEventListener('dragstart', event => event.preventDefault());
        // Keep editor image replacements in sync without a second hidden URL.
        new MutationObserver(() => show(current, false)).observe(thumbnailStrip, {
          subtree:true, childList:true, attributes:true, attributeFilter:['src','alt']
        });
        show(0, false);
        root.querySelectorAll('[role="button"]').forEach(el => el.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); el.click(); }
        }));
})();
